export default __webpack_public_path__ + "04dcfc2828adc2e6fd25563f3ab83498.png";